import { FormsModule } from '@angular/forms'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { TranslateModule } from '@ngx-translate/core'

import { BarsWidgetComponent } from './bars-widget/bars-widget.component'
import { PyramidWidgetComponent } from './pyramid-widget/pyramid-widget.component'
import { ListWidgetComponent } from './list-widget/list-widget.component'
import { PieChartWidgetComponent } from '.'
import { HideZeroValuesPipe } from '../common/hide-zero-values.pipe'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { StatsWidgetComponent } from './stats-widget/stats-widget.component'
import { BarChartWidgetComponent } from './bar-chart-widget/bar-chart-widget.component'
import { WidgetBaseComponent } from './widget-base/widget-base.component'
import { RadarChartWidgetComponent } from './radar-chart-widget/radar-chart-widget.component'
import { FloatingWidgetComponent } from 'app/widget/floating-widget/floating-widget.component'
import { ChartModule } from 'app/common/chart/chart.module'
import { SelectorComponent } from 'app/common/selector/selector.component'
import { ComparisonRankingListComponent } from './comparison-ranking-list/comparison-ranking-list.component'
import { CampaignWidgetComponent } from './campaign-widget/campaign-widget.component'
import { LatitudeAltModule } from '../latitude/latitude.module'

export { PieChartWidgetComponent } from './pie-chart-widget/pie-chart-widget.component'

const components = [
  SelectorComponent,
  FloatingWidgetComponent,
  BarsWidgetComponent,
  PyramidWidgetComponent,
  ListWidgetComponent,
  PieChartWidgetComponent,
  HideZeroValuesPipe,
  StatsWidgetComponent,
  BarChartWidgetComponent,
  RadarChartWidgetComponent,
  ComparisonRankingListComponent,
  WidgetBaseComponent,
  CampaignWidgetComponent,
]

@NgModule({
  imports: [
    CommonModule,
    ChartModule,
    TranslateModule,
    FormsModule,
    BrowserAnimationsModule,
    LatitudeAltModule,
  ],
  declarations: [...components],
  exports: [...components],
})
export class WidgetModule {}
